module.exports = __webpack_public_path__ + "img/circle1ORI.65dd3c08.svg";